import React from 'react'
import Modal, { ModalBody } from 'core-system/Modal'
import Text from 'core-system/Text/Text'
import styled from 'styled-components'
import palette from 'core-system/Themes/palette'

const SUPPORT_EMAIL = 'support@movewithfleet.com'

const ModalContainer = styled(Modal)`
  width: 30rem;
`

const Header = styled.div`
  padding: ${(props) =>
    `${props.theme.pxToRem(24)} ${props.theme.pxToRem(52)}`};
  background-color: ${(props) => props.theme.palette.white};
  color: ${(props) => props.theme.palette.text.primary};
  border-bottom: 1px solid ${(props) => props.theme.palette.grey.grey300};
`

const HeaderTitle = styled.div`
  ${(props) => props.theme.typography.h4}
  display: flex;
  align-items: center;
  padding-top: 0.125rem;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: left;
  padding: 0.5rem 0;
`

const SupportEmailLink = styled.a`
  color: ${(props) => props.theme.palette.primary.pink700};
  text-decoration: none;
`

interface AwaitingEmployerApprovalModalProps {
  open: boolean
}

const AwaitingEmployerApprovalModal = React.memo(
  ({ open }: AwaitingEmployerApprovalModalProps) => {
    return (
      <ModalContainer open={open} onClose={() => {}} disableEsc>
        <Header>
          <HeaderTitle>Welcome to Fleet 👋</HeaderTitle>
        </Header>
        <ModalBody>
          <Content>
            <Text variant='body1' fontWeight={600} marginBottom='0.5rem'>
              Your account is waiting for employer approval.
            </Text>
            <Text
              variant='action3'
              color={palette.text.secondary}
              marginBottom='0.75rem'
            >
              Please come back once your employer has approved you to join
              Fleet. You’ll be able to finish onboarding after your account is
              approved.
            </Text>
            <Text variant='action4' color={palette.text.secondary}>
              Need help? Email{' '}
              <SupportEmailLink href={`mailto:${SUPPORT_EMAIL}`}>
                {SUPPORT_EMAIL}
              </SupportEmailLink>
            </Text>
          </Content>
        </ModalBody>
      </ModalContainer>
    )
  }
)

if (process.env.NODE_ENV !== 'production') {
  AwaitingEmployerApprovalModal.displayName = 'AwaitingEmployerApprovalModal'
}

export default AwaitingEmployerApprovalModal
